import { CommonModule } from "@angular/common";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-animacion-video",
  imports: [CommonModule],
  templateUrl: "./animacion-video.component.html",
  styleUrls: ["./animacion-video.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AnimacionVideoComponent {
  /**
   * Input para indicar si el video se encuentra en estado de carga.
   * Utiliza un setter para actualizar el estado interno y forzar la detección de cambios.
   */
  @Input() set videoCargando(valor: any) {
    this.setVideoCargando(valor);
  }

  /**
   * @private
   * Valor interno que determina si el video está cargando.
   */
  private _videoCargando: boolean = false;

  /**
   * Getter que retorna el estado actual de carga del video.
   * @returns {boolean} true si el video está cargando, false en caso contrario.
   */
  get videoCargando(): boolean {
    return this._videoCargando;
  }

  /**
   * Input para habilitar/deshabilitar la acción de click en el componente.
   * Valor por defecto es true.
   */
  @Input() click: boolean = true;

  /**
   * Output que emite un evento para indicar que se debe cerrar la animación.
   */
  @Output() close = new EventEmitter();

  constructor(private cd: ChangeDetectorRef) {}

  /**
   * Actualiza el estado de carga del video y fuerza la detección de cambios.
   *
   * @param value Nuevo estado del video (true si está cargando, false si no).
   */
  public setVideoCargando(value: boolean) {
    this._videoCargando = value;
    this.cd.detectChanges();
  }

  /**
   * Método que se ejecuta al hacer click sobre el componente.
   * Emite el evento de cierre.
   */
  onClick() {
    this.close.emit();
  }
}
